<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t('tlt.energy.list') }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/energy"><span>{{$t('tlt.energy.list')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('energy')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">                                        
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="enyCodeFilter" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="enyNameFilter" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }}:
                                    </label>
                                    <select class="form-control" id="composite"  v-model="enyTypeFilter">
                                        <!-- <option>{{ $t("lbl.basic.select.one") }}</option> -->
                                        <option value="S">{{ $t("lbl.energy.type.solidty") }}</option>
                                        <option value="G">{{ $t("lbl.energy.type.gas") }}</option>
                                        <option value="F">{{ $t("lbl.energy.type.fluid") }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                        v-on:click="MMFClearFilter('energy')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('energy')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="energyResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="energy"
                                        inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/master/Energy";
import MmfTable from "@/components/MmfTable";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'energy/getField',
    mutationType: 'energy/updateField',
});

export default {
  name: "energyList",
  data () {
    return {
      checkedItems: []
    }
  },
  components: { MmfTable },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.energy.rows,
            tableColumns: gridFields,
            childs: state => state.energy.childs
        })
  },
  methods: {

    ...mapActions("energy", ["loadChildOf"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
      this.$store.dispatch('energy/loadChildOf');
  }
};
</script>
